import { render, staticRenderFns } from "./St32DailyForm.vue?vue&type=template&id=ba4d2796&"
import script from "./St32DailyForm.vue?vue&type=script&lang=js&"
export * from "./St32DailyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports